<template>
  <yxt-drawer
    :title="$t('pc_biz_ote_lbl_stumanage')"
    :visible.sync="isShow"
    size="960px"
    direction="rtl"
    :before-close="beforeClose"
  >
    <div class="yxtbiz-participants-drawer">
      <div class="flex flex-mid">
        <!--添加学员-->
        <template v-for="item in pageOperation">
          <yxt-button
            :key="item.label"
            :disabled="item.disabled?item.disabled():false"
            size="large"
            :plain="item.plain"
            :type="item.type"
            @click="item.action">
            {{ item.label }}
          </yxt-button>
        </template>
        <div class="flex-1 flex flex-mid ml16">
          <template v-if="arrangeInfo.uemAdding !== 0">
            <yxt-svg width="16px"
                     height="16px"
                     class="color-gray-7"
                     icon-class="sync" />
            <span class="font-size-14 color-gray-9 ml8">{{ $t('pc_biz_ote_lbl_syncstu') }}...</span>
          </template>
        </div>
        <yxtbiz-group-org-select
          v-if="groupSelect"
          :placeholder="$t('pc_biz_ote_lbl_plsselectorg')"
          class="mr12"
          :multiple="false"
          @change="changeOrg"
          ></yxtbiz-group-org-select>
        <!--请输入学员姓名、账号搜索-->
        <yxt-input
          v-model="params.name"
          :placeholder="$t('pc_biz_ote_lbl_practiceusersearch')"
          class="width240 ml12"
          searchable
          maxlength="20"
          @search="search(1)">
        </yxt-input>
      </div>
      <div class="participants-drawer--main">
        <common-table class="mt16"
                      :table-data="tableData"
                      :column-configs="columnConfigs"
                      :table-operation="tableOperation"
                      :loading="loading"
                      :selectable="true"
                      :selected.sync="multiSelection">
          <template slot="userName" slot-scope="{data}">
            <span>{{ data.userName }}</span>
          </template>
          <template slot="fullName" slot-scope="{data}">
            <div class="flex flex-mid">
              <yxt-tooltip effect="dark"
                           placement="top"
                           popper-class="yxtbiz-participants-max-tip"
                           :open-filter="true">
                <div slot="content">
                  <yxtbiz-user-name :name="data.fullName"/>
                </div>
                <div class="ellipsis">
                  <yxtbiz-user-name :name="data.fullName"/>
                </div>
              </yxt-tooltip>
              <!--  删除标识 -->
              <yxt-tag v-if="data.udpDeleted === 1"
                       class="ml5 ote-table-row__tag"
                       type="info"
                       size="mini">
                {{ $t('pc_biz_ote_lbl_deleted') }}
              </yxt-tag>
            </div>
          </template>
          <template slot="deptName" slot-scope="{data}">
            <yxt-tooltip v-if="data.deptName"
                         placement="top"
                         :open-filter="true"
                         popper-class="yxtbiz-participants-max-tip" >
              <div slot="content"><yxtbiz-dept-name :name="data.deptFullName" /></div>
              <div class="ellipsis">
                <yxtbiz-dept-name :name="data.deptName" />
              </div>
            </yxt-tooltip>
            <span v-else>--</span>
          </template>
        </common-table>

        <div class="flex flex-right mt16">
          <yxt-pagination
            v-if="pageData.count > 0"
            :page-size="params.limit"
            :total="pageData.count"
            :current-page="params.current"
            layout="total, prev, pager, next"
            @current-change="search"
          ></yxt-pagination>
        </div>
      </div>
    </div>
    <users-selector ref="userSelector" :groupSelect="groupSelect" permission-code="exam_add_appointCandidate_extent" @didSelect="doSelectUsers" :id="arrangeId" :batchId="batchId" :projectId="projectId" :taskId="taskId" />
  </yxt-drawer>
</template>

<script>
import CommonDropSelector from './component/CommonDropSelector';
import CommonTable from './component/CommonTable';
import { getRegExaminessProcess, getExaminees, batchDeleteExaminees, addExaminees } from '../service';
import UsersSelector from './UsersSelector';

export default {
  name: 'ParticipantsDrawer',
  components: { UsersSelector, CommonTable, CommonDropSelector },
  props: {
    // 是否集团化，支持跨机构选择
    groupSelect: {
      type: Boolean,
      default: false
    },
    // 循环考时的 安排的补考批次ID
    batchId: {
      type: String,
      required: false
    },
    // 支持项目内部添加补考人员
    projectId: {
      type: String,
      default: ''
    },
    // 支持项目多班次人员
    taskId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false,
      arrangeId: '', // 开始安排id
      params: { limit: 10 }, // 人员列表的查询参数
      pageOperation: [
        { label: this.$t('pc_biz_ote_lbl_addstudent'),
          type: 'primary',
          disabled: () => (this.arrangeInfo.uemAdding !== 0),
          action: this.toAddStudent },
        { label: this.$t('pc_biz_ote_btn_batchdel'),
          plain: true,
          disabled: () => (this.arrangeInfo.uemAdding !== 0),
          action: this.toBatchRemoveStudent }
      ],
      columnConfigs: [],
      tableOperation: [
        { label: this.$t('pc_biz_ote_lbl_remove'), action: this.toRemoveStudent }
      ],
      tableData: [],
      pageData: {},
      arrangeInfo: { uemAdding: 0 }, // 考试安排的详细信息
      loading: false,
      loadingTimeout: null,
      multiSelection: [] // 当前选择的人员
    };
  },
  watch: {
    groupSelect: {
      immediate: true,
      handler() {
        let cc = [
          { prop: 'userName', label: this.$t('pc_biz_ote_lbl_account'), minWidth: 100, showTooltip: true },
          { prop: 'fullName', label: this.$t('pc_biz_ote_lbl_cnname'), minWidth: 100, showTooltip: false },
          { prop: 'deptName', label: this.$t('pc_biz_ote_lbl_department'), minWidth: 100, showTooltip: false },
          { prop: 'mobile', label: this.$t('pc_biz_ote_lbl_phonenumber'), minWidth: 150 },
          { prop: 'email', label: this.$t('pc_biz_ote_lbl_email'), minWidth: 100, showTooltip: true }
        ];
        if (this.groupSelect) {
          cc.splice(2, 0, { prop: 'orgName', label: this.$t('pc_biz_ote_lbl_reforg'), minWidth: 100, showTooltip: true });
        }
        this.columnConfigs = cc;
      }
    }
  },
  methods: {
    /**
     * 打开参与人员的抽屉界面
     * 外部调用
     */
    show(info) {
      this.params = { limit: 10 };
      this.arrangeInfo = info;
      this.arrangeInfo.uemAdding = 0;
      this.arrangeId = info.arrangeId;
      this.isShow = true;
      this.getArrangeAllInfo();
    },
    /**
     * 获取考试全量信息
     */
    async getArrangeAllInfo() {
      this.loading = true;
      try {
        const res = await getRegExaminessProcess(this.arrangeInfo.arrangeId, this.batchId);
        this.arrangeInfo.uemAdding = res ? 1 : 0;
        if (this.arrangeInfo.uemAdding !== 0) {
          this.loadingTimeout = setTimeout(this.getArrangeAllInfo, 5000);
        } else {
          this.search(1);
        }
      } catch (e) {
        this.loading = false;
        this.handleError(e);
      }
    },
    changeOrg(org) {
      this.params.queryOrgId = org ? org.orgId : undefined;
      this.search();
    },
    /**
     * 查询人员列表 设置页码
     * @param page 页码
     */
    search(page = 1) {
      this.params.current = page;
      this.getAttendUserList();
    },
    /**
     * 获取人员列表
     * @return {Promise<void>}
     */
    async getAttendUserList() {
      this.loading = true;
      this.params.reqForResit = 1;
      this.params.batchId = this.batchId;
      const { datas = [], paging = {} } = await getExaminees(this.arrangeId, this.params);
      this.tableData = datas;
      this.pageData = paging;
      this.loading = false;
    },
    /**
     * 去打开添加学员的抽屉
     */
    toAddStudent() {
      this.$refs.userSelector.show();
    },
    /**
     * 选择人员的确定回调
     * @param users
     */
    doSelectUsers(users) {
      if (users.length === 0) {
        // 请选择需要添加的人员
        this.$alert(this.$t('pc_biz_ote_msg_selneedtobeadded'), this.$t('pc_biz_ote_msg_tip'), {
          confirmButtonText: this.$t('pc_biz_ote_btn_confirm')
        });
        return;
      }
      this.$refs.userSelector && this.$refs.userSelector.hide();
      this.loading = true;
      const userIds = users.map(item => item.userId);
      addExaminees(this.arrangeId, { userIds }, this.batchId).then(res => {
        this.getArrangeAllInfo();
      }).catch(this.handleError);
    },
    /**
     * 去批量删除学员
     */
    toBatchRemoveStudent() {
      const ids = this.multiSelection.map(item => item.id);
      this.doRemove(ids, this.$t('pc_biz_ote_msg_batchdelstu'));
    },
    /**
     * 去删除
     * @param obj 学员对象
     */
    toRemoveStudent(obj) {
      const ids = [obj.id];
      this.doRemove(ids, this.$t('pc_biz_ote_msg_delstu'));
    },
    /**
     * 删除的统一逻辑
     * @param ids 人员id数组
     * @param msg 提示信息
     */
    doRemove(ids, msg) {
      if (ids.length === 0) {
        this.$message({
          type: 'warning',
          message: this.$t('pc_biz_ote_msg_selcanditodel') // 请选择要删除的考生
        });
        return;
      }
      this.$confirm('', msg, {
        confirmButtonText: this.$t('pc_biz_ote_btn_confirm'),
        cancelButtonText: this.$t('pc_biz_ote_btn_cancle'),
        type: 'warning'
      }).then(() => {
        batchDeleteExaminees(this.arrangeId, ids, this.batchId).then(res => {
          this.$message({
            type: 'success',
            message: this.$t('pc_biz_ote_msg_deletesuccess') // 删除成功
          });
          this.getAttendUserList();
        }).catch(this.handleError);
      });
    },
    beforeClose(done) {
      this.$emit('close');
      return done(false);
    },
    handleError(error) {
      if (error && error.error) {
        // 兼容处理
        error = error.error;
      }
      if (error) {
        if (error.key && error.key.indexOf('global.token') >= 0) {
          return; // 不弹出token错误
        }
        let msg = error.message;
        this.$message({
          message: msg,
          type: 'error'
        });
      }
    }
  },
  beforeDestroy() {
    this.loadingTimeout && clearTimeout(this.loadingTimeout);
  }
};
</script>
